// Dependencies
import {
  ChangeEventHandler,
  FC,
  FocusEventHandler,
  MouseEventHandler,
  ReactElement,
} from "react";

// Components
import TextInput from "~/components/Common/TextInput";
import { IconButton, Typography } from "@mui/material";

// Styles
import { StyledFormItem } from "./FormInput.styled";

interface FormInputProps {
  label: string;
  type: string;
  name: string;
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
  value: string | number;
  icon?: ReactElement;
  placeholder?: string;
  autoComplete?: string;
  onIconClick?: MouseEventHandler;
}

const FormInput: FC<FormInputProps> = ({
  icon,
  label,
  onIconClick,
  ...props
}) => {
  return (
    <StyledFormItem>
      <Typography variant="h3" key={1}>
        {label}
      </Typography>
      <TextInput
        key={2}
        endAdornment={<IconButton onClick={onIconClick}>{icon}</IconButton>}
        {...props}
      ></TextInput>
    </StyledFormItem>
  );
};

export default FormInput;
